
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    normalizedName(): string {
      return this.name ? this.name.replaceAll(" ", "_") : "--";
    },
  },
});
